import React, { useEffect } from 'react';
import { useFetchFullEido_Colors } from 'hooks/fetch/useFetchFullEido_Colors';

const FullEidoBoostrap = () => {
  // Fetch and update colors from API
  const { clr, res } = useFetchFullEido_Colors();
  
  useEffect(() => {
    if (res) {
      // Optionally, do something when colors are ready, e.g., log or apply side effects
      // console.log('Colors updated:', clr);
    }
  }, [clr, res]);

  return null
};

export default FullEidoBoostrap;
